import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00233 = new TileLayer({
  title: 'Máscara 20061009',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20061009l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00233.setVisible(false);

const layer00232 = new TileLayer({
  title: 'Máscara 20061110',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20061110l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00232.setVisible(false);
  
const layer00231 = new TileLayer({
  title: 'Máscara 20061220',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20061220l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00231.setVisible(false);

const layer00230 = new TileLayer({
  title: 'Máscara 20070302',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070302l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00230.setVisible(false);

const layer00229 = new TileLayer({
  title: 'Máscara 20070310',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070310l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00229.setVisible(false);
 
const layer00228 = new TileLayer({
  title: 'Máscara 20070318',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070318l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00228.setVisible(false);

const layer00227 = new TileLayer({
  title: 'Máscara 20070505',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070505l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00227.setVisible(false);
 
const layer00226 = new TileLayer({
  title: 'Máscara 20070529',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070529l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00226.setVisible(false);

const layer00225 = new TileLayer({
  title: 'Máscara 20070622',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070622l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00225.setVisible(false);

const layer00224 = new TileLayer({
  title: 'Máscara 20070630',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070630l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00224.setVisible(false);
  
const layer00223 = new TileLayer({
  title: 'Máscara 20070708',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070708l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00223.setVisible(false);

const layer00222 = new TileLayer({
  title: 'Máscara 20070724',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070724l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00222.setVisible(false);
  
const layer00221 = new TileLayer({
  title: 'Máscara 20070809',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20070809l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00221.setVisible(false);

export const grupoCapa01_15 = new LayerGroup({
  title: 'Ciclo Hidrológico 2006-2007',
  fold: 'close',
  layers: [layer00221, layer00222, layer00223, layer00224, layer00225, layer00226, layer00227, layer00228, layer00229, layer00230, layer00231, layer00232, layer00233]
});